export default "__VITE_ASSET__DeV46TUP__"